export const isEmpty = (val: string | unknown[] | Set<unknown> | Map<unknown, unknown>) => {
    if (val instanceof Map || val instanceof Set) return val.size === 0;
    return val.length === 0;
};
